import React from 'react';
import styled from 'styled-components';
import { iconStyles } from '../../styles/css';

const StyledSVG = styled.svg<{ $rotation: number }>`
  ${iconStyles}

  transform: rotate(${props => props.$rotation}deg);
`;

const SVGIcon: React.FC<{
  width: number;
  height: number;
  rotation: number;
  [x: string]: any;
}> = ({ children, width, height, rotation = 0, ...rest }) => (
  <StyledSVG
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $rotation={rotation}
    {...rest}
  >
    {children}
  </StyledSVG>
);

export default SVGIcon;
